module.exports = __webpack_public_path__ + "static/media/not_found.e9ff6ff5.gif";